import { Badge } from "@/components/ui/badge";

export function confidenceMeta(score) {
  if (score == null) return { label: "Pending", cls: "bg-zinc-100 text-zinc-500 border-zinc-200" };
  if (score >= 95) return { label: `${score}% Certain`, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" };
  if (score >= 85) return { label: `${score}% Strong`, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" };
  if (score >= 70) return { label: `${score}% Probable`, cls: "bg-amber-50 text-amber-700 border-amber-200" };
  if (score >= 50) return { label: `${score}% Review`, cls: "bg-orange-50 text-orange-700 border-orange-200" };
  return { label: `${score}% Uncertain`, cls: "bg-red-50 text-red-700 border-red-200" };
}

export default function ConfidenceBadge({ score, className = "", testid }) {
  const m = confidenceMeta(score);
  return (
    <Badge data-testid={testid} variant="outline" className={`font-mono-p text-[11px] rounded-sm border ${m.cls} ${className}`}>
      {m.label}
    </Badge>
  );
}
